import { createStore } from 'redux'

import TimeslotReducer from './reducers/TimeslotReducer'

const createdStore = createStore(TimeslotReducer)

export const store = createdStore
